import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation } from "swiper/modules"
import "swiper/css"

export default class extends Controller {
	static targets = ["slider", "prev", "next"]

	connect() {
		this.slider = new Swiper(this.sliderTarget, {
			modules: [Navigation],
			speed: 750,
			longSwipesMs: 100,
			longSwipesRatio: 0.2,
			navigation: {
				prevEl: this.prevTarget,
				nextEl: this.nextTarget
			}
		})
	}
}
